(function () {
  'use strict';

  var config = window.themeConfig || {};

  /* ── Formatage des prix ─────────────────── */
  function formatMoney(cents) {
    var fmt = config.moneyFormat || '{{amount_with_comma_separator}} €';
    var amount = (cents / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  /* ── Toast ───────────────────────────────── */
  var toast = document.getElementById('toast');
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('show'); }, 2200);
  }

  /* ── Panier (drawer) ─────────────────────── */
  var drawer = document.getElementById('cartDrawer');
  var overlay = document.getElementById('overlay');
  var cartItemsBox = document.getElementById('cartItems');
  var cartCountEl = document.getElementById('cartCount');
  var cartTotalEl = document.getElementById('cartTotal');
  var freeShipEl = document.getElementById('freeShip');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay.classList.add('open');
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
  }

  function renderCart(cart) {
    if (cartCountEl) cartCountEl.textContent = cart.item_count;
    if (cartTotalEl) cartTotalEl.textContent = formatMoney(cart.total_price);

    if (freeShipEl) {
      var threshold = config.freeShippingThreshold || 0;
      if (!cart.item_count || !threshold) {
        freeShipEl.textContent = '';
      } else if (cart.total_price >= threshold) {
        freeShipEl.textContent = '🎉 Livraison offerte !';
      } else {
        freeShipEl.textContent = 'Plus que ' + formatMoney(threshold - cart.total_price) + ' pour la livraison offerte 🚚';
      }
    }

    if (!cartItemsBox) return;
    if (!cart.items.length) {
      cartItemsBox.innerHTML = '<div class="cart-empty">Votre panier est vide 🛒<br><small>Ajoutez des produits pour commencer</small></div>';
      return;
    }
    cartItemsBox.innerHTML = cart.items.map(function (item, i) {
      var variant = item.product_has_only_default_variant ? '' :
        '<small class="variant">' + escapeHtml(item.variant_title || '') + '</small>';
      var img = item.image ?
        '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') + '" alt="" loading="lazy">' : '';
      return '<div class="cart-item">' +
        '<div class="thumb">' + img + '</div>' +
        '<div class="info">' +
          '<b>' + escapeHtml(item.product_title) + '</b>' + variant +
          '<div class="qty">' +
            '<button data-line="' + (i + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Réduire">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button data-line="' + (i + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Augmenter">+</button>' +
          '</div>' +
          '<br><button class="remove" data-line="' + (i + 1) + '" data-qty="0">Supprimer</button>' +
        '</div>' +
        '<div class="line-price">' + formatMoney(item.final_line_price) + '</div>' +
      '</div>';
    }).join('');
  }

  function fetchCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { showToast('Erreur, veuillez réessayer'); });
  }

  function addToCart(id, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      addBtn.disabled = true;
      addToCart(parseInt(addBtn.dataset.variantId, 10), 1)
        .then(function () { return fetchCart(); })
        .then(function () {
          showToast('✔ Produit ajouté au panier');
          openCart();
        })
        .catch(function (err) { showToast(err && err.description ? err.description : 'Erreur, veuillez réessayer'); })
        .finally(function () { addBtn.disabled = false; });
      return;
    }

    var qtyBtn = e.target.closest('#cartItems [data-line]');
    if (qtyBtn) {
      changeLine(parseInt(qtyBtn.dataset.line, 10), Math.max(0, parseInt(qtyBtn.dataset.qty, 10)));
      return;
    }

    if (e.target.closest('#cartBtn')) { e.preventDefault(); fetchCart(); openCart(); return; }
    if (e.target.closest('#closeCart') || e.target === overlay) { closeCart(); return; }
    if (e.target.closest('#checkoutBtn')) { window.location.href = '/checkout'; return; }
  });

  /* ── Formulaire produit (AJAX) ───────────── */
  var productForm = document.querySelector('form[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = parseInt(productForm.querySelector('[name="id"]').value, 10);
      var qtyInput = productForm.querySelector('[name="quantity"]');
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var submitBtn = productForm.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      addToCart(id, qty)
        .then(function () { return fetchCart(); })
        .then(function () {
          showToast('✔ Produit ajouté au panier');
          openCart();
        })
        .catch(function (err) { showToast(err && err.description ? err.description : 'Erreur, veuillez réessayer'); })
        .finally(function () { if (submitBtn) submitBtn.disabled = false; });
    });

    var variantSelect = document.getElementById('variantSelect');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        var priceEl = document.getElementById('productPrice');
        var compareEl = document.getElementById('productCompare');
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        if (compareEl) {
          if (opt.dataset.compare) {
            compareEl.textContent = opt.dataset.compare;
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
      });
    }
  }

  /* ── Galerie produit ─────────────────────── */
  document.querySelectorAll('.thumb-img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.getElementById('mainImage');
      if (main && thumb.dataset.full) {
        main.src = thumb.dataset.full;
        document.querySelectorAll('.thumb-img').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      }
    });
  });

  /* ── Menu mobile ─────────────────────────── */
  var burger = document.getElementById('burger');
  var mainNav = document.getElementById('mainNav');
  if (burger && mainNav) {
    burger.addEventListener('click', function () { mainNav.classList.toggle('open'); });
    mainNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mainNav.classList.remove('open'); });
    });
  }

  /* ── Sélection du pays par défaut ────────── */
  document.querySelectorAll('select[data-default]').forEach(function (sel) {
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].text === sel.dataset.default) { sel.selectedIndex = i; break; }
    }
  });

  fetchCart();
})();
